<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-chip
        v-on="on"
        small
        v-bind="$attrs"
        @click="handleItemClick"
        style="cursor: pointer;"
      >
        N°{{ requestId }}
      </v-chip>
    </template>
    <span>
      {{ generateMessage('requests.item.link') }}
    </span>
  </v-tooltip>
</template>
<script>
import { generateMessage } from '@/utils/i18n';

export default {
  name: 'LinkToRequest',
  props: {
    requestId: {
      type: Number,
      required: true,
    },
    propertyId: {
      type: Number,
      required: true,
    },
    daugtherId: {
      type: Number,
      required: false,
    },
  },
  methods: {
    generateMessage,
    handleItemClick() {
      this.$store.dispatch('requests/setCurrentActive', {
        property_id: this.propertyId,
        id: this.requestId,
        daughter_request_id: this.daugtherId,
      });
    },
  },
};
</script>
